<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <ul v-for="subModulePage in subModulePages"
        :key="subModulePage.to.name"
        class="menu-list">
        <li>
          <router-link :to="subModulePage.to"
            active-class="is-active"
            exact>
            <span>
              {{ subModulePage.label }}
            </span>
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import SuperadminSystemModuleRoutes from './route-types'

export default {
  name: 'SystemModuleSideMenu',
  components: {
    AppSideMenu
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    subModulePages() {
      return [
        {
          to: { name: SuperadminSystemModuleRoutes.SystemModulesDetail.name },
          label: 'FlexiQuote Module',
          isShow: true
        }
      ]
    }
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>